// Hideo - demo data of the main profile when it has never been saved. Created in the UI language (it becomes user
// content); status and priority are stored values and never change language. In practice only users who had data
// before profiles existed have the main profile, so new users never see it.
import { t } from '../i18n'
import { DEF_PROFILE } from './profiles'

const defaultData = () => ({
  scripts: [],
  videos: [{
    id: 'v1', title: t('iPhone 18 Pro review'), link: 'https://docs.google.com', status: 'In Script', format: 'Long Form', priority: 'Alta',
    thumbnail: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=600&auto=format&fit=crop',
    checklist: { script: true, audio: false, thumbnail: false }, notes: t('Focus on camera and battery life.')
  }],
  creators: [{ id: 'c1', name: t('Test 2'), types: ['Competitor'], avatar: '', banner: '', youtube: '', instagram: '', tiktok: '', twitch: '', notes: '', analyzedVideos: [] }],
  sources: [{ id: 's1', title: t('YouTube Trends report'), tags: [t('Research')], url: 'https://www.youtube.com/trends', note: t('Verified data, updated monthly.') }],
  vault: [{ id: 'vt1', tags: [t('Opening')], title: t('Hooks that work'), content: t('Start with the end result, then explain how.') }]
})

/** Starting data of a never-saved profile: the demo only for the main one */
export const emptyData = (id: string): Record<string, unknown> => (id === DEF_PROFILE ? defaultData() : {})
